<div
  class="user-view"
  [ngClass]="[
    selectable ? 'selectable' : '',
    grayBackground ? 'gray-background' : '',
  ]"
  (click)="changeUser()"
>
  <div class="display-flex ion-align-items-center">
    <app-avatar [user]="user"> </app-avatar>

    <div class="display-flex flex-direction-column margin-left-8">
      <div *ngIf="showUserText" class="user-text">
        {{ "USER" | translate }}
      </div>
      <ion-label
        class="username"
        *ngIf="user"
        [ngClass]="{
          'weight-bold': grayBackground
        }"
      >
        {{ user.firstName }}
        {{ user.lastName ? " " + user.lastName : "" }}
      </ion-label>
      <ion-label *ngIf="user?.company">
        {{ user.company?.name }}
      </ion-label>
    </div>
  </div>
  <div *ngIf="selectable" class="color-pink">{{ "CHANGE" | translate }}</div>
  <!-- <ion-icon *ngIf="selectable" (click)="changeUser()" class="task-transfer" src="../../../assets/icons/people-arrows-solid.svg"></ion-icon> -->
</div>
